import { Settings } from '../../../shared/providers';

export const settings: Settings = {
    env: 'testing',
    upscoreApiUrl: {
        production: 'https://api.upscore.no/api',
        testing: 'https://api-qa.upscore.no/api',
    },
    onescoreApiUrl: {
        production: 'https://api.data.eiendomsfinans.no/v1',
        testing: 'https://api.dev.data.eiendomsfinans.no/v1',
    },
    altinnLogin: {
        production: {
            baseURL: 'https://www.altinn.no/api',
            apiKey: 'A866EB19-F9D8-451B-81CC-DE36A3413C9D',
        },
        testing: {
            baseURL: 'https://api-qa.upscore.no/api',
            apiKey: '1F31B84D-6352-4333-B359-206583071F65',
        },
    },
    firebase: {
        production: {
            apiKey: 'AIzaSyCadFZzt5Mq8HHRRmUG6nAA_HmdUYl0tyg',
            authDomain: 'karmascore-227513.firebaseapp.com',
            databaseURL: 'https://karmascore-227513.firebaseio.com',
            projectId: 'karmascore-227513',
            storageBucket: 'karmascore-227513.appspot.com',
            messagingSenderId: '235643059684',
            appId: '1:235643059684:web:5a254600591e122c',
        },
        testing: {
            apiKey: 'AIzaSyAUd-dF92eSDsf4nqp8X5q10dnhlnfrTvk',
            authDomain: 'karmascore-staging-227513.firebaseapp.com',
            databaseURL: 'https://karmascore-staging-227513.firebaseio.com',
            projectId: 'karmascore-staging-227513',
            storageBucket: 'karmascore-staging-227513.appspot.com',
            messagingSenderId: '907293560391',
            appId: '1:907293560391:web:629071c2d5a9c180',
        },
    },
    languageVersion: 'upscore',
    altinnDataTypes: ['taxReturn'],
    trackingServices: {
        activeInDevMode: false,
        sanitazedNetworkRequests: [
            'hotjar.com',
            'hotjar.io',
            'vimeo.com',
            'app.appzi.io',
            'appzi-collector',
            'google-analytics.com',
            'sentry.io',
            'netlify',
        ],
        googleTagManager: {
            active: true,
            gtmId: 'GTM-KG3BN3S',
        },
        sentry: {
            active: true,
            dsn: 'https://cbf8a838c5804372afd836b40dc01225@sentry.io/2464524',
            // dsn:
            //     'https://bcae51a496a448a6869df44dd3ccf109@o561094.ingest.sentry.io/5697558',
        },
        logRocket: {
            active: true,
            reactPlugin: true,
            identifyTracking: true,
            dom: {
                textSanitizer: false,
                inputSanitizer: true,
            },
            workspace: 'hqlaue/upscore',
        },
    },
};
